import styled from "react-emotion";

const TrackInfo = styled("div")`
  grid-column: 1;
  grid-row: 4 / -1;
`;

export default TrackInfo;
